module.exports = __webpack_public_path__ + "static/media/ico-resize.a29f7fbc.svg";